import { InjectionToken, Signal } from '@angular/core';

export interface FormFieldContext {
  readonly isErrorShown: Signal<boolean>;
  readonly describedByIds: Signal<string | null>;
}

export const FORM_FIELD_CONTEXT = new InjectionToken<FormFieldContext>(
  'FORM_FIELD_CONTEXT',
);
